import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import {BsFacebook,BsTwitter,BsWhatsapp} from 'react-icons/bs'
import {SiGmail} from 'react-icons/si'
import {EmailShareButton, FacebookShareButton, TwitterShareButton,WhatsappShareButton } from 'react-share';

export default function Share() {
  const location = useLocation();
  const updateLinks = new URLSearchParams(location.search).get('updateLinks');
  console.log(updateLinks);
  const [isCopied, setIsCopied]=useState(false);
  const handleCopyToClipboard = async()=>{
    try{
      await navigator.clipboard.writeText(updateLinks);
      setIsCopied(true)
    }catch(error){
      console.error('Error copying to clipboard', error);
    }
  }

  return (
    <div className="mt-20 mx-auto md:w-96 w-80 md:max-w-screen-xl sm:px-10 px-6 py-16 shadow-xl mb-6 ">
      <h1 className="text-2xl font-semibold mb-4">Share Product</h1>
      {updateLinks && (
        <div>
          <p>Share this link:</p>
          <input
            type="text"
            value={updateLinks}
            readOnly
            className="border border-gray-300 dark:border-gray-700 rounded-md px-3 py-2 w-full mb-2"
          />
          <button
          type='button'
          onClick={handleCopyToClipboard}
          className='bg-[#6c757d] hover:bg-[#6c757d]/80 text-white rounded-md px-4 py-2 mb-4'>
             {isCopied ? 'Copied!' : 'Copy Link'}
          </button>
          <div className="mt-4">
            <h2 className="text-xl font-semibold mb-2">Share on Social Media</h2>
            <FacebookShareButton url={updateLinks}>
              <BsFacebook size={44}/>
            </FacebookShareButton>
            <TwitterShareButton url={updateLinks}>
              <BsTwitter size={44} className='mx-6'/>
            </TwitterShareButton>
            <EmailShareButton url={updateLinks}>
                <SiGmail size={44}/>
            </EmailShareButton>
            <WhatsappShareButton url={updateLinks}>
                <BsWhatsapp size={44} className='mx-6'/>
            </WhatsappShareButton>
          </div>
        </div>
      )}
    </div>
  );
}
